import React, { useCallback, useMemo } from "react";
import { View } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Button } from "../../../../atom/button/Button";
import { useAnswerForId } from "../../behaviours/useAnswers";
import { useAnswersValidation } from "../../behaviours/useAnswersValidation";
import { QuestionItemState, useQuestionItemState } from "../../behaviours/useQuestionItemState";
import { style as roundedButtonWithIconOnSelectedQuestionItemStyle } from "./RoundedButtonWithIconOnSelectedQuestionItem.style";
const ICON = {
    ["quiz.icon.avoid"]: "avoid",
    ["style_profile.icon.avoid"]: "avoid",
};
const RoundedButtonWithIconOnSelectedQuestionItem = ({ domain, segment, question, questionParentId, }) => {
    const titleText = useI18nMessage({ domain, id: question.translationKey, values: { segment: segment.toLowerCase() } });
    const { answer, onChange } = useAnswerForId({ id: questionParentId });
    const selectedAnswer = answer && answer.find((id) => id === question.id);
    const { validateMaxAnswers } = useAnswersValidation();
    const state = useQuestionItemState({ questionParentId, question });
    const handleOnChange = useCallback(() => {
        onChange({ questionId: question.id, answer: selectedAnswer ? undefined : question.id });
        validateMaxAnswers();
    }, [onChange, question.id, selectedAnswer, validateMaxAnswers]);
    const icon = selectedAnswer ? ICON[question.metadata.icon] : undefined;
    const checked = state === QuestionItemState.SELECTED;
    const style = useMemo(() => roundedButtonWithIconOnSelectedQuestionItemStyle(), []);
    return (React.createElement(View, { style: style.container, testID: "rounded-button-with-icon-on-selected-question-item" },
        React.createElement(Button, { checked: checked, icon: icon, style: { button: style.button }, testID: question.id, title: titleText, onPress: handleOnChange })));
};
export { RoundedButtonWithIconOnSelectedQuestionItem };
